import t from"dlv";export default function(e,r){return function(n){var a=n&&n.target||this,o="string"==typeof r?t(n,r):a.nodeName?a.type.match(/^che|rad/)?a.checked:a.value:n;return e(o)}}
//# sourceMappingURL=linkfunction.es.js.map
